import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {Accordion, AccordionHeader, AccordionItem, AccordionPanel} from '@adv-mt/ui/accordion'
import {Body1} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import {ACCORDION_HEADER_ICONS} from '../accordionHeaderIcons.js'
import BaseDrawer from '../BaseDrawer/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-certificationDrawer`

const CertificationDrawer = ({features = [], onClose}) => {
  const {i18n} = useSuiContext()

  return (
    <BaseDrawer onClose={onClose} title={i18n.t('COMMON.DETAIL_CERTIFICATION_BENEFITS_TITLE')}>
      <Accordion>
        {features.map(({description, title}) =>
          description ? (
            <AccordionItem key={title} value={title}>
              <AccordionHeader {...ACCORDION_HEADER_ICONS}>{title}</AccordionHeader>
              <AccordionPanel>{description}</AccordionPanel>
            </AccordionItem>
          ) : (
            <AccordionItem key={title}>
              <div className={`${BASE_CLASS}-staticItem`}>
                <Body1 highlight>{title}</Body1>
              </div>
            </AccordionItem>
          )
        )}
      </Accordion>
    </BaseDrawer>
  )
}

CertificationDrawer.displayName = 'CertificationDrawer'

CertificationDrawer.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      title: PropTypes.string
    })
  ),
  onClose: PropTypes.func.isRequired
}

export default CertificationDrawer
